import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import { PageTitle } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconCompensationPlan,
  IconPresentation,
  IconMediaKit
} from '../../styles/Icons';

import {
  HeaderIcon,
  ResourcesBody,
  ResourcesContainer,
  ResourcesHeader,
  Title
} from './ResourcesStyled';

export const Resources = () => {
  const { t } = useTranslation('resources');
  return (
    <AnimatedDashboard zoom>
      <PageTitle>{t('resources')}</PageTitle>
      <ResourcesContainer>
        <ResourcesHeader>
          <HeaderIcon>
            <Icon color={color.colors.neutral50}>
              <IconPresentation />
            </Icon>
          </HeaderIcon>

          <Title>{t('presentation')}</Title>
        </ResourcesHeader>
        <ResourcesBody>
          <a
            href='https://resources.bighearts.global/presentations/big_hearts_presentation.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Big Hearts Presentation (ENG)</li>
          </a>
        </ResourcesBody>
      </ResourcesContainer>

      <ResourcesContainer>
        <ResourcesHeader>
          <HeaderIcon>
            <Icon color={color.colors.neutral50}>
              <IconCompensationPlan />
            </Icon>
          </HeaderIcon>

          <Title>{t('momentum_plan')}</Title>
        </ResourcesHeader>
        <ResourcesBody>
          <a
            href='https://resources.bighearts.global/presentations/Compensation_Plan_BH.pdf'
            target='_blank'
            rel='noreferrer'>
            <li>Big Hearts Compensation Plan (ENG)</li>
          </a>
        </ResourcesBody>
      </ResourcesContainer>
    </AnimatedDashboard>
  );
};
